export default {
  status: true,
  custominfo: [],
  coypright: "版权信息",
  coyprightLineColor: "#b4a172",
  coyprightTextColor: "#b4a172",
  coyprightFontSize: 12,
  bgColor: "#b4a172"
};